export default __webpack_public_path__ + "static/media/11_PM_CityID.9a0ed602.pdf";